import { useEffect, useState } from "react";
import Lenis from "lenis";
import Marquee from "react-fast-marquee";
import { Lightning } from "@phosphor-icons/react";
import { api, trackPage } from "../lib/api";
import { subscribeContentUpdates } from "../lib/contentSync";
import { useLang } from "../i18n";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import KategoriPrestasi from "../components/landing/KategoriPrestasi";
import Atlet from "../components/landing/Atlet";
import Coach from "../components/landing/Coach";
import Jadwal from "../components/landing/Jadwal";
import Galeri from "../components/landing/Galeri";
import Video from "../components/landing/Video";
import Pengumuman from "../components/landing/Pengumuman";
import Berita from "../components/landing/Berita";
import Rekomendasi from "../components/landing/Rekomendasi";
import Gabung from "../components/landing/Gabung";
import Sponsor from "../components/landing/Sponsor";
import Footer from "../components/landing/Footer";

export default function Home() {
    const { t } = useLang();
    const [content, setContent] = useState(null);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        trackPage("/");
        const load = () => {
            api.get("/content")
                .then((r) => setContent(r.data))
                .catch(() => setContent({ achievements: [], news: [], shops: [], sponsors: [], settings: {} }));
        };
        load();
        return subscribeContentUpdates(load);
    }, []);

    if (!content) {
        return (
            <div className="min-h-screen bg-white flex items-center justify-center" data-testid="home-loading">
                <span className="font-display uppercase text-black/30 text-xl tracking-widest animate-pulse">Mandalika</span>
            </div>
        );
    }

    const { achievements, athletes, coaches, schedules, announcements, gallery, videos, news, shops, sponsors, settings } = content;

    return (
        <div className="bg-white text-neutral-900 min-h-screen" data-testid="home-page">
            <Navbar settings={settings} />
            <Hero settings={settings} medals={achievements.length} />

            {settings.banner_text ? (
                <a
                    href={settings.banner_link || undefined}
                    target={settings.banner_link ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    data-testid="top-banner"
                    className="block bg-[#FFB800] text-[#1c1917] text-center text-[11px] uppercase tracking-[0.25em] px-6 py-3 hover:bg-[#E0A300] transition-colors duration-300"
                >
                    {settings.banner_text}
                </a>
            ) : null}

            <div className="border-y border-[#B8190A] bg-[#D21E06] py-5 overflow-hidden" data-testid="manifesto-marquee">
                <Marquee speed={30} gradient={false}>
                    {t.marquee_words.map((w, i) => (
                        <span key={i} className="mx-8 flex items-center gap-8 font-display uppercase text-xl md:text-2xl text-white">
                            {w}
                            <Lightning size={18} weight="fill" className="text-white/80" />
                        </span>
                    ))}
                </Marquee>
            </div>

            <Atlet athletes={athletes.filter((a) => (a.status ?? "active") !== "inactive")} topSupported={content.top_supported || []} />
            <Pengumuman announcements={announcements} />
            <Berita news={news} />
            <KategoriPrestasi />
            <Rekomendasi shops={shops} />
            <Coach coaches={coaches} />
            <Jadwal schedules={schedules} />
            <Galeri gallery={gallery} />
            <Video videos={videos} />
            <Sponsor sponsors={sponsors} settings={settings} />
            <Gabung settings={settings} />
            <Footer settings={settings} />
        </div>
    );
}
